import { render, staticRenderFns } from "./PageDesignTop.vue?vue&type=template&id=1ddb73bd&scoped=true"
import script from "./PageDesignTop.vue?vue&type=script&lang=js"
export * from "./PageDesignTop.vue?vue&type=script&lang=js"
import style0 from "./PageDesignTop.vue?vue&type=style&index=0&id=1ddb73bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddb73bd",
  null
  
)

export default component.exports